// Consulta compartida para la verificacion de token.
// Los proveedores de contexto se montan todos juntos en App y cada uno repetia el mismo POST
// contra un endpoint lento, por lo que una sola carga disparaba siete llamadas identicas.
// Este helper agrupa esas solicitudes en una sola durante una ventana corta.

export const VIGENCIA_VERIFICACION_TOKEN_MS = 15000;

let entrada = null;

const construirClave = (url, token) => `${url}|${token}`;

const descartarSiEs = (solicitud) => {
  if (entrada && entrada.solicitud === solicitud) {
    entrada = null;
  }
};

/**
 * Devuelve la solicitud compartida de verificacion de token.
 * Resuelve con { ok, rol, error } para que cada consumidor conserve su propia comparacion
 * y su propio manejo de errores sin volver a parsear la respuesta.
 * Cuando la respuesta no es ok el cuerpo no se parsea: el backend responde texto plano.
 */
export const obtenerVerificacionToken = (url, token) => {
  const clave = construirClave(url, token);
  const ahora = Date.now();

  if (entrada && entrada.clave === clave && ahora < entrada.vence) {
    return entrada.solicitud;
  }

  const solicitud = fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ Token: token }),
  })
    .then((response) => {
      if (!response.ok) {
        return { ok: false, rol: null, error: null };
      }

      return response
        .json()
        .then((rol) => ({ ok: true, rol, error: null }))
        .catch((error) => ({ ok: true, rol: null, error }));
    })
    .catch((error) => {
      // Una falla de red no debe quedar servida durante toda la ventana.
      descartarSiEs(solicitud);
      throw error;
    });

  entrada = {
    clave,
    solicitud,
    vence: ahora + VIGENCIA_VERIFICACION_TOKEN_MS,
  };

  return solicitud;
};

/** Limpia la ventana compartida; se usa en los tests. */
export const reiniciarVerificacionToken = () => {
  entrada = null;
};
